import { render } from "./bottomMenu.vue?vue&type=template&id=d2cc38a8&scoped=true"
import script from "./bottomMenu.vue?vue&type=script&lang=js"
export * from "./bottomMenu.vue?vue&type=script&lang=js"

import "./bottomMenu.vue?vue&type=style&index=0&id=d2cc38a8&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cc38a8"]])

export default __exports__